import script from "./FaqPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqPage.vue?vue&type=script&setup=true&lang=ts"

import "./FaqPage.vue?vue&type=style&index=0&id=90e7b268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90e7b268"]])

export default __exports__